export default function PricingSection() {
  const priceRanges = [
    {
      title: '法人格のみの休眠会社',
      price: '10万円〜50万円',
      icon: 'ri-building-line',
      color: 'from-teal-500 to-cyan-500'
    },
    {
      title: '許認可のある休眠会社',
      price: '各許認可の取得費用に応じる',
      icon: 'ri-file-shield-line',
      color: 'from-cyan-500 to-blue-500'
    },
    {
      title: '事業譲渡などのM&A',
      price: '事業の売上に応じる',
      icon: 'ri-line-chart-line',
      color: 'from-blue-500 to-indigo-500'
    }
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-20">
          <div className="inline-flex items-center px-6 py-3 bg-teal-50 rounded-full mb-6">
            <i className="ri-price-tag-3-line text-teal-600 text-xl mr-3"></i>
            <span className="text-sm font-bold text-teal-600">PRICING</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-black text-gray-900 mb-6">
            販売価格・<span className="bg-gradient-to-r from-teal-500 to-cyan-500 bg-clip-text text-transparent">相場</span>
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            売主様からは手数料を頂戴しておりません
          </p>
        </div>

        {/* Key Points */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16">
          <div className="bg-gradient-to-br from-teal-50 to-cyan-50 rounded-3xl p-8 border-2 border-teal-200">
            <div className="w-16 h-16 bg-gradient-to-br from-teal-500 to-cyan-500 rounded-2xl flex items-center justify-center mb-6 shadow-lg">
              <i className="ri-money-dollar-circle-line text-3xl text-white"></i>
            </div>
            <h3 className="text-2xl font-black text-gray-900 mb-4">手数料ゼロ</h3>
            <p className="text-base text-gray-700 leading-relaxed">
              売主様からは手数料を頂戴しておりません。安心してご相談ください。
            </p>
          </div>

          <div className="bg-gradient-to-br from-gray-50 to-white rounded-3xl p-8 border-2 border-gray-200">
            <div className="w-16 h-16 bg-gradient-to-br from-gray-700 to-gray-900 rounded-2xl flex items-center justify-center mb-6 shadow-lg">
              <i className="ri-discuss-line text-3xl text-white"></i>
            </div>
            <h3 className="text-2xl font-black text-gray-900 mb-4">譲渡代金について</h3>
            <p className="text-base text-gray-700 leading-relaxed">
              譲渡代金はお客様のご希望に沿って決定いたします。おおよその相場をご案内させていただきます。
            </p>
          </div>
        </div>

        {/* Price Ranges */}
        <div>
          <h3 className="text-2xl font-black text-gray-900 mb-8 text-center">会社販売価格の相場</h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {priceRanges.map((range, index) => (
              <div key={index} className="group bg-white rounded-2xl p-6 border-2 border-gray-200 hover:border-teal-500 transition-all duration-300 hover:shadow-xl">
                <div className={`w-14 h-14 bg-gradient-to-br ${range.color} rounded-xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300 shadow-lg`}>
                  <i className={`${range.icon} text-2xl text-white`}></i>
                </div>
                <h4 className="text-lg font-black text-gray-900 mb-3">{range.title}</h4>
                <p className="text-2xl font-black bg-gradient-to-r from-teal-500 to-cyan-500 bg-clip-text text-transparent">
                  {range.price}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
